import React, { useMemo } from 'react';
import { find } from 'lodash';
import withBackSupport from 'components/HOCs/withBackSupport';
import Page from './Page';
import { useRouteMatch } from 'react-router';
import { useSelector } from 'react-redux';
import { appSelectors } from 'store/app';

const SectionContainer = () => {
  const match = useRouteMatch();
  const isHomePage = match.path === '/';
  const menuItems = useSelector(appSelectors.selectMenuItems);
  const currentMenuItem = useMemo(() => find(menuItems, { path: match.path }), [match, menuItems]);

  if (!currentMenuItem) return null;

  return <Page currentMenuItem={currentMenuItem} isHomePage={isHomePage} />;
};

export default withBackSupport(SectionContainer);
